import Overlay from '../node_modules/ol/Overlay.js';

import polygonArea from './util/polygonArea.js';
import inverse from './inverse.js';
import calcLength from './calcLength.js';
import formatDist from './util/formatDist.js';

/* Constructor */
export default function(map, className) {
  var element = document.createElement('div');
  var cssClasses = 'tooltip tooltip-measure';
  if (className) {
    cssClasses += ' ' + className;
  }

  element.className = cssClasses;

  this.overlay = new Overlay({
    element: element,
    offset: [0, -15],
    positioning: 'bottom-center'
  });

  map.addOverlay(this.overlay);

  /**
   * parameters {string}
   */
  this.update = function(geom, mode) {  // mode = 'create' | 'modify'
    let output
    let tooltipCoord
    const geomType = geom.getType()
    const geomInfoLabel = document.getElementById('geom-info-label')

    if (geomType === 'Polygon') {
      output = polygonArea(geom)
      if (output) {
        output.replace('Area: ', ' ')
      }
      tooltipCoord = geom.getInteriorPoint().getCoordinates()
      let geomInfoLabel = document.getElementById('geom-info-label')
      if (geomInfoLabel) {
        document.getElementById('geom-info-label').innerHTML = 'Area:'
      }
    } else if (geomType === 'LineString') {
      // totalLength = (rwg.geodesic) ? calcLength(geom) : geom.getLength(); // calcLength() is rwg function, getLength() is ol3 function
      let distTotal = calcLength(geom); // calcLength() is rwg function, getLength() is ol3 function
      if (mode === 'modify') {
        output = (distTotal > 0 ) ? 'Total: ' + formatDist(distTotal) : ''
      } else { // drawing a new line
        // https://gis.stackexchange.com/questions/270273/using-stoppropagation-in-openlayers-4
        let oldCoordsLen = geom.get('coordsLen')
        let newCoordsLen = geom.getCoordinates().length
        // detect double click, 1st node oldCoordsLen will be undefined
        // double click newCoordsLen will be less than oldCoordsLen
        if (oldCoordsLen === undefined || newCoordsLen >= oldCoordsLen) {
          geom.set('coordsLen', newCoordsLen)
          let bearingDistance = inverse(geom)
          output = bearingDistance
          if (distTotal > 0) {
            output += ' Total: ' + formatDist(distTotal)
          }
        }
      } // drawing a new line
      tooltipCoord = geom.getLastCoordinate()
      if (geomInfoLabel) {
        document.getElementById('geom-info-label').innerHTML = 'Length:'
      }
    }
    if (output) {
      element.innerHTML = output
      this.overlay.setPosition(tooltipCoord)
      if (document.getElementById('geom-info')) {
        document.getElementById('geom-info').innerHTML = output
      }
    }
  };

  this.remove = function() {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
    map.removeOverlay(this.overlay);
  };

}
